import axios from 'axios';
import config from "@/config"
import { message } from "ant-design-vue"
import store from "@/store"
const service = axios.create({
  baseURL: config.Base_Port + 'api/',
  method: config.method ? config.method : 'POST',
  withCredentials: true,
  timeout: 30000   // 请求时间
})
let wxapp_id
if (config.isPro) {
  wxapp_id = 10008 //国采云
} else {
  wxapp_id = 10015 //国采云
  // wxapp_id = 10008 //a企购
}

// 发送处理
service.interceptors.request.use(
  config => {
    if (config.method === 'post') {
      config.data = {
        ...config.data,
        _t: Date.parse(new Date()) / 1000,
        wxapp_id
      }
    } else if (config.method === 'get') {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params,
        wxapp_id
      }
    }
    store.state.loadding = true;
    return config
  },
  error => {      //debug
    return Promise.reject(error)
  }
)

// 返回结果处理
service.interceptors.response.use(
  response => {
    const res = response.data

    if (res.code !== config.Response.success) {
      message.error(res.msg) //接口非正常处理
      store.state.loadding = false;
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      localStorage.setItem("date", new Date().getTime())
      store.state.loadding = false;
      // store.dispatch('user/reflashToken')
      return res
    }

  },
  error => {
    const msg = error.message.includes('timeout') ? '请求超时' : error.message
    message.error(msg)
    return Promise.reject(error)
  }
)
export default service
